module.exports = __webpack_public_path__ + "static/media/add-file.84371f25.svg";